// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { mergeWithCss } from "@steiner/XDL/Utilities";
import React, { FC, PropsWithChildren, useState } from "react";

interface OwnProps {
    title?: string;
    extendedStyles?: CheckoutBoxStyles;
}

export interface CheckoutBoxStyles {
    container?: InjectableCss;
    title?: TypographyPresentationProps;
    innerContainer?: InjectableCss;
}

export const checkoutBoxStyles: CheckoutBoxStyles = {};

const CheckoutBox: FC<PropsWithChildren<OwnProps>> = ({ title, children, extendedStyles }) => {
    const [styles] = useState(() => mergeWithCss(checkoutBoxStyles, extendedStyles));

    return (
        <StyledWrapper {...styles.container}>
            <Typography {...styles.title}>{title}</Typography>
            <StyledWrapper {...styles.innerContainer}>{children}</StyledWrapper>
        </StyledWrapper>
    );
};

export default CheckoutBox;
